// extracted by mini-css-extract-plugin
export default {"items":"delivery_items__LMRO-","item":"delivery_item__5m1JE","input":"delivery_input__WvoD+","buttons":"delivery_buttons__M9X5M","registerBtns":"delivery_registerBtns__LxQfA"};